<div class="negotiations-price-form">
  <label for="negotiations-start-price">
    {{ 'LOT_INFO.NEGOTIATIONS_PRICE' | translate }} (JPY)
  </label>
  <nz-input-number
    nzId="negotiations-start-price"
    class="negotiations-price-input"
    [(ngModel)]="price"
    [nzMin]="1"
    [nzPrecision]="0"
    [nzStep]="10000"
  ></nz-input-number>
</div>

<ng-container *nzModalFooter>
  <button nz-button [disabled]="loading$ | async" (click)="close()">
    {{ 'CANCEL' | translate }}
  </button>
  <button
    nz-button
    nzType="primary"
    [disabled]="!canSave"
    [nzLoading]="loading$ | async"
    (click)="saveNegotiationsPrice()"
  >
    {{ 'SAVE' | translate }}
  </button>
</ng-container>
